import { render, staticRenderFns } from "./fund-question.vue?vue&type=template&id=67ce43fa&scoped=true&"
import script from "./fund-question.vue?vue&type=script&lang=js&"
export * from "./fund-question.vue?vue&type=script&lang=js&"
import style0 from "./fund-question.vue?vue&type=style&index=0&id=67ce43fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ce43fa",
  null
  
)

export default component.exports